import { PublicHealthExplorerDependentOldInput, Relation, Sex } from "src/data";

export interface Applicant {
  relation: Relation;
  age: number;
  sex: Sex;
}

/**
 * Translates a basic applicant into the dependent payload
 */
export function getDependentPayload(applicant: Applicant): PublicHealthExplorerDependentOldInput {
  return {
    age: applicant.age,
    relation: applicant.relation,
    sex: applicant.sex,
    isApplying: true,
    aptcEligible: true,
    hasMec: false,
    isParent: false,
    isSmoker: false,
  }
}